import { HookScreenNavigateIn_ReturnType } from "../../../../../../../_ovlclient/src/global/hooks"
import { SYSAction } from "../../../../../../../_ovlclient/src/index"
import { FieldSetVal } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  NewServiceFormStep1FieldsDef,
  NewServiceStep1FormFieldKeys,
} from "../../../features/svl/svlnewservicestep1/formdef"
const HookScreenNavigateIn: SYSAction<any> = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let formState = await FormInit(
    "SVLNewServiceStep1",
    NewServiceFormStep1FieldsDef,
    {
      doFormChangedForEveryFieldInInit: false,
      initialFocusFieldKey: <NewServiceStep1FormFieldKeys>"problemType",
    }
  )
  let urlParams = state.app.global.GEN.submittedUrlParams
  if (!urlParams.urlHandled) {
    urlParams.urlHandled = true
    let group = "Service"
    if (urlParams.problemTypeId > -1) {
      group =
        state.app.global.SVL.lookups.problemType.data[urlParams.problemTypeId][
          "Group"
        ]
      FieldSetVal(formState.fields["problemType"], urlParams.problemTypeId)
    }
    if (urlParams.groupName) {
      group = urlParams.groupName
    }
    if (group) {
      FieldSetVal(formState.fields["group"], group, {
        ignoreCustomValidation: true,
        ignoreValueChanged: true,
      })
    }
  }
}

export let hooks = { HookScreenNavigateIn }
